import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Button, Breadcrumb, Confirm } from 'semantic-ui-react'
import { lower } from 'change-case'

import RequestInfo from '../Shareds/RequestInfo'
import GeneralInfo from '../Shareds/GeneralInfo'
import POItemInfo from '../Shareds/POItemInfo'
import Attachment from '../Shareds/Attachment'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { getSpecialApproval, getProjectByCompany } from 'ducks/goa'
import { purchaseOrderUpdatePath } from 'routes'
import {
  validateField,
} from '../helper'
import { 
  MainBodyContent, 
  CustomButton,
} from 'components'
import { 
  initializePOUpdate,
  fetchPOComplete,
  createPOUpdate,
  getPOUGOAWorkFlowEditMode,
  checkPOUpdateInprocess,
  getPOCompleteDetail,
  clearPOCompleteDetail,
  clearPOUpdateData,
  closeCreatorSubmitConfirm,
  submitPOUpdate
} from 'ducks/poUpdate'
import { 
  showModal,
} from 'ducks/app'

import { BottomActionsContainer } from './styled'
// import r from 'reactotron-react-js'

const CreatePOUpdate = props => {

  const { 
    history,
    valueForm,
    change,
    poComplete,
    checkPOUpdate,
    poCompleteDetail,
    isDetail = false,
  } = props

  const [actionName, setActionName] = React.useState('')
  const [poValid, setPOValid] = React.useState(false)
  const [showConfirm, setShowConfirm] = React.useState(false)

  React.useEffect(() => {
    window.scrollTo(0,0)
    props.initializePOUpdate(isDetail)
    props.fetchPOComplete(true, null, 'Create')
    return(()=>{
      props.clearPOUpdateData()
    })
  },[])

  const showAlertPOInprocess = () => {
    props.showModal(
      true, 
      'Alert',
      checkPOUpdate.data.docStatus==0?
      `PO "${checkPOUpdate.data.poSapNumber}" has been crated draft  by ${checkPOUpdate.data.createdByName}.`
      :
      `PO "${checkPOUpdate.data.poSapNumber}"  has been created the request. Please check and complete request no."${checkPOUpdate.data.poUpdateDocNumber}" before submit .`,
      'tiny'
    )
  }

  React.useEffect(() => {
    if(valueForm&&valueForm.poSelect){
      let po = poComplete.data.find(x=>x.poSapNumber == valueForm.poSelect)
      if(po){
        props.checkPOUpdateInprocess(0,po.poSapNumber)
        props.getPOCompleteDetail(po.poSapNumber,'Create')
        change('companyName',`${po.companyCode} | ${po.companyName}`)
        change('projectName',po.projectName)
        change('poId',po.poId)
        change('purchaseOrderNumber',po.poSapNumber)
        change('purchaseGroupCode',po.purchGroup)
        change('goaId',po.goaid)
        change('companyCode',po.companyCode)
      }
    }else{
      change('poId','')
      change('purchaseOrderNumber','')
      change('purchaseGroupCode','')
      change('companyCode','')
      change('projectName','')
    }
  },[(valueForm&&valueForm.poSelect)])

  React.useEffect(()=>{
    if(checkPOUpdate.data.isInprocess){
      setPOValid(false)
      showAlertPOInprocess()
    }else{
      setPOValid(true)
    }
  },[checkPOUpdate])

  React.useEffect(() => {
    if(valueForm&&valueForm.poSelect){
      if(Object.keys(poCompleteDetail).length>0){
        props.getPOUGOAWorkFlowEditMode({
          creater:props.userName,
          requester:valueForm.requesterUser,
          companyCode:poCompleteDetail.companyCode,
          purchaseGroup:valueForm.purchaseGroupCode,
          poSapNumber:poCompleteDetail.poSapNumber,
          account:valueForm.accounting||false,
          legal:valueForm.legal||false,
          procurement:valueForm.purchasing||false,
          goaId:poCompleteDetail.goaid,
          specialApprovalId:valueForm.specialApprovalId
        })
      }
    }
  },[poCompleteDetail,
    (valueForm&&valueForm.requesterUser),
    (valueForm&&valueForm.accounting),
    (valueForm&&valueForm.legal),
    (valueForm&&valueForm.purchasing),
    (valueForm&&valueForm.specialApprovalId)])

  React.useEffect(()=>{
    if(valueForm&&valueForm.projectId){
      props.getSpecialApproval(valueForm.projectId)
      if(Object.keys(props.specialApprovals).length>0){
        change('specialApprovalId','')
      }
    }
  },[(valueForm&&valueForm.projectId)])

  React.useEffect(()=>{
    if(valueForm&&valueForm.companyCode){
      props.getProjectByCompany(valueForm.companyCode)
    }
  },[(valueForm&&valueForm.companyCode)])

  React.useEffect(()=>{
    if(Object.keys(poCompleteDetail).length>0){
      change('projectId',poCompleteDetail.projectId)
      change('projectName',poCompleteDetail.projectName)
      change('specialApprovalId',poCompleteDetail.specialApprovalId)
    }
  },[poCompleteDetail])

  const onSubmitForm = () => {
    setShowConfirm(false)
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms)) 
    return sleep(100)
    .then(() => {
      let errors = validateField(valueForm)
      if(Object.keys(errors).length){
        scrollToFirstValidateFailElement(errors)
        throw new SubmissionError(errors)
      }else{
        if(poValid){
          props.createPOUpdate(valueForm, history, (actionName=='submit'))
        }else{
          showAlertPOInprocess()
        }
      }
    })
  } 

  const confirmSubmit = () =>{
    props.submitPOUpdate({id:props.creatorSubmitConfirm.id}, history)
  }

  return (
    <MainBodyContent
      headerTitle='Update/Cancel PO - Create '
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => props.history.push(purchaseOrderUpdatePath)}
            icon="close"
            btnColor="red"
            title="Cancel"
          />
        </div>
      }
      breadcrumbs={
        <Breadcrumb
          icon="right angle"
          sections={[
            {
              key: 'pou',
              content: 'Update/Cancel PO',
              link: true,
              onClick: () => history.push(purchaseOrderUpdatePath),
            },
            { key: 'pouCreate', content: 'Create', active: true },
          ]}
        />
      }
    >
      <RequestInfo isCreate/>
      
      <GeneralInfo isCreate history={history}/>

      {valueForm&&valueForm.poSelect&&
      <POItemInfo isCreate/>}
      <Attachment isCreate isEdit={false} change={change}/>
      <Confirm
        size='tiny'
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={props.handleSubmit(()=>onSubmitForm())}
      />
      <Confirm
        size='tiny'
        open={props.creatorSubmitConfirm.show}
        content={props.creatorSubmitConfirm.message}
        onCancel={() => props.closeCreatorSubmitConfirm()}
        onConfirm={() => confirmSubmit()}
      /> 
      <form onSubmit={props.handleSubmit(()=>onSubmitForm())}>
        <BottomActionsContainer>
          <Button 
            type='button'
            content='Save' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={()=>{
              setActionName('save')
              setShowConfirm(true)
            }}
          />
          <Button 
            type='button'
            content='Save & Submit' 
            color='blue' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={()=>{
              setActionName('submit')
              setShowConfirm(true)
            }}
          />
        </BottomActionsContainer>
      </form>
    </MainBodyContent>
  )

}

const mapStateToProps = (state) => {
  const date = new Date()
  const userName = state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : ''
  let requesterUser = ''
  if (userName) {
    requesterUser = lower(userName)
  }
  return ({
    initialValues: {
      documentDate:new Date(date.getFullYear(), date.getMonth(), date.getDate()),
      requesterUser:requesterUser,
      purchasing:true,
      requestTypes:[]
    },
    checkPOUpdate: state.poUpdate.checkPOUpdate,
    poCompleteDetail: state.poUpdate.poCompleteDetail.data,
    specialApprovals:state.goa.specialApprovals,
    creatorSubmitConfirm: state.poUpdate.creatorSubmitConfirm,
    userName,
    poComplete: state.poUpdate.poComplete,
    valueForm: getFormValues('formPOUpdate')(state),
  })
}
const mapDispatchToProps = {
  initializePOUpdate,
  fetchPOComplete,
  createPOUpdate,
  getPOUGOAWorkFlowEditMode,
  checkPOUpdateInprocess,
  getPOCompleteDetail,
  clearPOCompleteDetail,
  clearPOUpdateData,
  getSpecialApproval,
  getProjectByCompany,
  closeCreatorSubmitConfirm,
  submitPOUpdate,
  showModal
}

const contForm = reduxForm({
  form: 'formPOUpdate',
  enableReinitialize: true,
})(CreatePOUpdate)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
